// extracted by mini-css-extract-plugin
export default {"info":"style_info__sT+AK","spinner":"style_spinner__0stan"};